import { useContext, useEffect } from 'react'
import {
    ActionIcon,
    Box,
    Divider,
    Flex,
    Image,
    Modal,
    Paper,
    Text,
    Title,
} from '@mantine/core'

import BIGIMAGE from '../../../images/BIGIMAGE.svg'
import DOWNLOAD from '../../../images/DOWNLOAD.svg'
import { QuizContext } from '@context/QuizContext'
import RoundButton from '@components/button/RoundButton'
import PIG from '../../../images/PIGICON.svg'
import ConcludeSection from '../ConcludeSection'
import Money from '../../../utils/Money'
import { usePDF } from '@react-pdf/renderer'
import PDFGenerator from '@utils/PDFGenerator'
import FormSubmitPDF from '../FormSubmitPDF'
import { useDisclosure } from '@mantine/hooks'
import Quiz from '@api/Quiz'
const QuizSectionEight = () => {
    const {
        form8,
        formContact,
        currentStep,
        retirement_age,
        payment_after_retirement_each_month,
        payment_after_retirement_each_year,
        long_term_inflation_assumption,
        payment_at_retirement_first_year,
        expected_rate_of_return_before_retirement,
        required_funds_for_retirement,
        estimated_rate_return_after_retirement,
        estimated_saving_source_for_retirement,
        dificit_funds_retirement,
        investment_rate_for_expect_return_two_percent,
        investment_rate_for_expect_return_four_percent,
        investment_rate_for_expect_return_six_percent,
        investment_rate_for_expect_return_eight_percent,
        resetStep,
        data,
        quiz_id,
    } = useContext(QuizContext)
    const [instance, update] = usePDF({
        document: <PDFGenerator data={data!} />,
    })

    const [opened, { open, close }] = useDisclosure(false)

    useEffect(() => {
        update(<PDFGenerator data={data!} />)
    }, [data])

    const suggests = {
        column1: ['2.00%', '4.00%', '6.00%', '8.00%'],
        column2: [
            investment_rate_for_expect_return_two_percent,
            investment_rate_for_expect_return_four_percent,
            investment_rate_for_expect_return_six_percent,
            investment_rate_for_expect_return_eight_percent,
        ],
    }

    const { onSubmit } = Quiz.useUpdateQuiz({
        form: form8,
    })

    if (quiz_id) form8!.values.quiz_id = quiz_id

    if (currentStep !== 7) {
        return <></>
    }

    return (
        <>
            <Paper my='xl' shadow='xl' p={{ xs: 'lg', lg: 72 }} radius='lg'>
                <Flex gap='sm' align='center'>
                    <Image src={PIG} w={40} />
                    <Title order={3} c='fuchasia.4'>
                        สรุปผลการวิเคราะห์
                    </Title>
                </Flex>
                <Divider my='xl' variant='dashed' />
                <Flex direction='column' gap='xl'>
                    <ConcludeSection label='การวิเคราะห์เป้าหมายทางการเงินที่ต้องการเพื่อการเกษียณ'>
                        คุณต้องการเกษียณเมื่ออายุ {retirement_age} ปี
                        และมีเงินใช้จ่ายหลังเกษียณ{' '}
                        {Money(payment_after_retirement_each_month!, 0)}{' '}
                        บาท/เดือน หรือ{' '}
                        {Money(payment_after_retirement_each_year!, 0)} บาท/ปี
                        (มูลค่าในปัจจุบัน) จากการวิเคราะห์พบว่า ที่อัตราเงินเฟ้อ{' '}
                        {long_term_inflation_assumption}% ต่อปี
                        จำนวนเงินที่ต้องการมีไว้ใช้จ่ายเมื่อเกษียณอายุในปีแรกที่เกษียณอายุ
                        เท่ากับ {Money(payment_at_retirement_first_year!, 0)}{' '}
                        บาท/ปี ที่อัตราผลตอบแทนคาดหวังหลังเกษียณ{' '}
                        {estimated_rate_return_after_retirement}% ต่อปี
                        เงินทุนเพื่อการเกษียณทั้งหมดที่ต้องมี ณ
                        ปีแรกที่เกษียณอายุ เท่ากับ{' '}
                        {Money(required_funds_for_retirement!, 0)} บาท
                    </ConcludeSection>
                    <ConcludeSection label='การวิเคราะห์แหล่งเงินออมเพื่อการเกษียณ'>
                        จากการประมาณการที่อัตราผลตอบแทนคาดหวังก่อนเกษียณ{' '}
                        {expected_rate_of_return_before_retirement}% ต่อปี พบว่า
                        แหล่งเงินออมเพิ่อการเกษียณที่เตรียมไว้แล้ว ณ
                        ปีที่เกษียณอายุ จะมีมูลค่าเท่ากับ{' '}
                        {Money(estimated_saving_source_for_retirement!, 0)} บาท
                    </ConcludeSection>
                    <ConcludeSection label='การวิเคราะห์และส่วนขาดเกินของแหล่งเงินออม'>
                        {dificit_funds_retirement! > 0 ? (
                            <Text c='redt'>
                                จากการคำนวนพบว่า
                                คุณมีส่วนขาดของเงินทุนเพื่อการเกษียณที่ต้องการ{' '}
                                {Money(dificit_funds_retirement!)} บาท
                            </Text>
                        ) : (
                            <Text c='green'>
                                จากการคำนวนพบว่า
                                คุณไม่มีส่วนขาดของเงินทุนเพื่อการเกษียณ
                            </Text>
                        )}
                    </ConcludeSection>
                    {dificit_funds_retirement! > 0 && (
                        <ConcludeSection label='คำแนะนำเพิ่มเติม'>
                            <Flex
                                gap='xl'
                                direction={{ xs: 'column', lg: 'row' }}
                            >
                                <Flex direction='column'>
                                    <Text>
                                        ท่านควรนำเงินมาออมและลงทุนเพิ่มเติมเพื่อบรรลุเป้าหมายการเกษียณอายุ
                                    </Text>
                                    <Flex mt='md' gap={{ xs: 'xl', md: 100 }}>
                                        <Flex direction='column' gap='lg'>
                                            <Text>อัตราผลตอบแทนคาดหวัง</Text>
                                            {suggests.column1.map(
                                                (value, index) => (
                                                    <Text
                                                        key={value + index}
                                                        ta='center'
                                                    >
                                                        {value}
                                                    </Text>
                                                )
                                            )}
                                        </Flex>
                                        <Flex direction='column' gap='lg'>
                                            <Text>เงินลงทุน (บาท/เดือน)</Text>
                                            {suggests.column2.map(
                                                (value, index) => (
                                                    <Text
                                                        key={value! + index}
                                                        ta='center'
                                                    >
                                                        {Money(value!)}
                                                    </Text>
                                                )
                                            )}
                                        </Flex>
                                    </Flex>
                                </Flex>
                                <Box
                                    ml='auto'
                                    maw={500}
                                    mx='auto'
                                    w={{ xs: '100%', md: '35%' }}
                                >
                                    <Image w={'100%'} src={BIGIMAGE} />
                                </Box>
                            </Flex>
                        </ConcludeSection>
                    )}
                </Flex>
            </Paper>
            <Flex
                mb='xl'
                direction={{ xs: 'column', sm: 'row' }}
                align={{ xs: 'center', sm: 'end' }}
                gap='lg'
                justify={{ xs: 'center', sm: 'space-between' }}
            >
                <Flex
                    align={{ xs: 'center', sm: 'end' }}
                    gap='md'
                    direction={{ xs: 'column', sm: 'row' }}
                    justify={{ xs: 'center', sm: 'space-between' }}
                >
                    <RoundButton
                        type='button'
                        onClick={() => resetStep!()}
                        label='ทำแบบประเมินอีกครั้ง'
                        h={50}
                    />

                    <Flex gap='md' align={'flex-end'}>
                        <a
                            rel='noreferrer'
                            download='Report.pdf'
                            href={instance.url!}
                        >
                            <ActionIcon
                                color='fuchasia.4'
                                h={50}
                                w={50}
                                radius='xl'
                            >
                                <Image w='40px' src={DOWNLOAD} />
                            </ActionIcon>
                        </a>
                    </Flex>
                </Flex>

                <Flex
                    align={{ xs: 'center', sm: 'start' }}
                    direction={'column'}
                >
                    {data?.person_type === 1 ? (
                        <Title
                            fz={{
                                xs: '1.1rem',
                                sm: '1.1rem',
                                md: '1.1rem',
                                lg: '1.2rem',
                            }}
                            c='fuchasia.5'
                            order={2}
                            style={{ textAlign: 'center' }}
                            mb='lg'
                        >
                            เลือกบริการที่ใช่สำหรับคุณ
                        </Title>
                    ) : null}

                    <Flex
                        align={{ xs: 'center', sm: 'end' }}
                        gap='md'
                        direction={{ xs: 'column-reverse', sm: 'row' }}
                        justify={{ xs: 'center', sm: 'space-between' }}
                    >
                        {data?.person_type === 1 ? (
                            <RoundButton
                                onClick={open}
                                w={{ xs: '100%' }}
                                type='submit'
                                label='ขอรับคำปรึกษากับทางที่ปรึกษาทางการเงิน'
                                miw={{ xs: '100%', sm: 'auto' }}
                            />
                        ) : null}

                        <RoundButton
                            onClick={() => {
                                onSubmit()
                                return window.open(
                                    data?.person_type === 1
                                        ? 'https://online.muangthai.co.th/th/worksite/?utm_source=retirementcheck&utm_medium=calculation&utm_campaign=employee'
                                        : 'https://online.muangthai.co.th/th?utm_source=retirementcheck&utm_medium=calculation&utm_campaign=generalpublic',
                                    '_blank'
                                )
                            }}
                            w={{ xs: '100%' }}
                            type='submit'
                            label='ค้นหาแบบประกันที่ใช่'
                            miw={{ xs: '100%', sm: 'auto' }}
                        />

                        <Modal
                            opened={opened}
                            size={'xl'}
                            onClose={() => {
                                formContact!.reset()
                                close()
                            }}
                        >
                            <FormSubmitPDF
                                quiz_id={quiz_id as number}
                                pdf={instance.blob}
                                formContact={formContact}
                                close={close}
                                person_type={data?.person_type as number}
                            />
                        </Modal>

                        {data?.person_type === 1 ? (
                            <RoundButton
                                onClick={() => {
                                    onSubmit()
                                    return window.open(
                                        'https://forms.gle/4u37SghNanwJ5J8X6 ',
                                        '_blank'
                                    )
                                }}
                                w={{ xs: '100%' }}
                                type='submit'
                                label='ผลิตภัณฑ์กองทุนรวม'
                                miw={{ xs: '100%', sm: 'auto' }}
                            />
                        ) : null}
                    </Flex>
                </Flex>
            </Flex>
        </>
    )
}

export default QuizSectionEight
